import { getConfig } from '@klpkonsern/appconfig';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_GOOGLEMAPS_API_KEY: string;
    }
}

// Helper functions
export const getGoogleMapsApiKey = (): string =>
    getConfig('WEBAPP_GOOGLEMAPS_API_KEY', '');

export const GoogleMapsRegions = {
    no: 'NO',
    da: 'DK',
    en: 'GB',
};
